export class RequestBase {
    RequestID: number;
    UserName : string;
}
export class RequestStudentsCreditList {
    RequestID: number;
    ID_mon: number;
    UserName : string;
}